import React, { Fragment, Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { h } from '@app/helpers/translationHelper'
import InlineForm from './InlineForm'

import SVG from 'react-inlinesvg'
import plus from '@icons/plus/white'

class Footer extends Component {
  constructor (props) {
    super(props)
  }

  render() {
    const { config, createEnabled } = this.props

    if (!this.props.updatedOn || !createEnabled) { return null }

    const {
      olympiads,
      createStudentAction,
      updateStudentAction,
      deleteStudentAction,
      student,
      students
    } = this.props

    return (
      <Fragment>
        <div className="content-indent">
          <InlineForm
            number={students.length + 1}
            student={student}
            olympiads={olympiads}
            config={config}
            createStudentAction={createStudentAction}
            updateStudentAction={updateStudentAction}
            deleteStudentAction={deleteStudentAction}
          />
        </div>
        <div className="separator" />
      </Fragment>
    )
  }
}

Footer.propTypes = {
  students: PropTypes.array.isRequired,
  student:  PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  olympiads: PropTypes.array.isRequired,
  createStudentAction: PropTypes.func.isRequired,
  updateStudentAction: PropTypes.func.isRequired,
  group_id: PropTypes.string
}

export default Footer
